<template>
    <div>
        <div class="d-flex flex-row justify-content-center">
            <div class="first-connect-wallet mt-5 m-4">
                <div class="d-flex flex-row  justify-content-center first-connect-wallet-inside" style="margin:3.5rem 3rem 3rem 3rem">
                    <img class="first-connect-wallet-inside-head" src="../assets/images/eggs-game.png" alt="">
                </div>
                <div class="d-flex flex-row justify-content-center" style="margin: 5rem 3rem 0 3rem">
                    <img class="first-connect-wallet-inside-snakes" src="../assets/images/hue-saturation-3.webp" alt="">
                </div>
                <div class="d-flex flex-row justify-content-center mb-5" style="margin-top: -1rem">
                    <button class="connect-wallet-button" @click="walletConnect">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img class="first-connect-wallet-inside-button-image" src="../assets/images/connect-wallet-button.webp" alt="">
                            <span class="connect-wallet-button-text"> {{ buttonText }} </span>
                        </div>
                    </button>
                </div>
            </div>
            <welcome-parchment></welcome-parchment>
        </div>
    </div>
</template>
<script>
import WelcomeParchment from './WelcomeParchment.vue'
export default {
    name:'connect-wallet',
    props: {
        buttonText: {
            default: "Connect Wallet",
            type: String
        }
    },
    components:{WelcomeParchment },
    data(){
        return{

        }
    },
    methods:{
        walletConnect(){
            this.$emit('connectWallet' , true)
        }
    }
}
</script>
<style scoped>
    .first-connect-wallet{
        background-image: url('../assets/images/first-component-web.webp');
        background-size: 602px 789px;
        background-repeat: no-repeat;
        width: 602px;
        height: 789px;
    }
    .connect-wallet-button-text{
        color: #907242;
        position: absolute;
        font-size: 38px;
        top: 10px
    }
    .connect-wallet-button:hover{
        text-shadow: 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287;
    }
    .connect-wallet-button{
        border: none;
        background: none
    }
    .minting-parsomen-tube{
        margin-top: 135px;
    }
    .welcome-text{
        color: #000000;
        font-size: 83px;
    }
    .nft-image-text{
        margin: 20px 0 0 64px
    }
    .nft-information-text{
        color: #000000 !important;
        font-size: 16px !important;
        margin-top: 0px;
        width: 76%;
    }
    .welcome-chicken-text{
        width: 350px;
        text-align: left;
        margin-top: 35px;
        margin-left: 5px;
        line-height: 19px;
    }
    .welcome-snake-image{
        margin: 25px 31px 0 7px;
    }
    .welcome-snake-text{
        width: 350px;
        line-height: 19px;
        margin: 30px 0 0 40px;
    }
    .welcome-rooster-image{
        margin: 20px 12px 0 0;
    }
    .welcome-rooster-text{
        width: 370px;
        margin: 30px 0 0 0;
        line-height: 19px;
    }
    .currency-information{
        margin-top: 20px;
        text-align: center;
    }
    .currency-information-text{
        color: #2a2a2a !important;
        font-size: 35px !important;
        margin-top: 15px;
        line-height: 30px;
        width: 85%;
        margin-left: 10px;
        text-align: center;
    }
    .currency-information-inside{
        width: 360px;
        line-height: 19px;
        text-align: center;
        margin-top: 5px;
    }
    @media (max-width: 1300px) {
        .first-connect-wallet{
            background-size: 400px 550px;
            width: 400px;
            height: 550px;
        }
        .welcome-chicken-text{
            width: 270px;
            line-height: 15px;
            margin-top: 15px;
            text-align: left;
        }
        .welcome-snake-image{
            margin-top: 10px;
        }
        .welcome-snake-text{
            line-height: 15px;
            margin-top: 10px;
        }
        .welcome-rooster-text{
            line-height: 15px;
            width: 260px;
            margin-top: 20px;
        }
        .welcome-chicken{
            width: 48px;
            height: 68px;
        }
        .welcome-snake{
            width: 61px;
            height: 60px;
        }
        .welcome-rooster{
            width: 57.3px;
            height: 68px;
        }
        .first-connect-wallet-inside-head {
            width: 260px;
        }
        .first-connect-wallet-inside-snakes{
            width: 265px;
        }
        .first-connect-wallet-inside-button-image{
            width: 270px;
        }
        .connect-wallet-button-text{
            font-size: 20px;
        }
        .minting-parsomen-tube{
            margin-top: 40px;
        }
        .minting-parsomen-tube img{
            width: 350px;
        }
        .welcome-parchment{
            background-size: 400px 550px;
            width: 400px;
            height: 550px;
        }
        .welcome-text{
            color: #000000;
            font-size: 50px;
        }
        .nft-image-text{
            margin: 15px 0 0 44px
        }
        .nft-information-text{
            color: black !important;
            font-size: 11px !important;
        }
        .currency-information{
            margin-top: 0;
        }
        .currency-information-text{
            color: #2a2a2a !important;
            font-size: 25px !important;
        }
        .currency-information-inside{
            width: 250px;
            line-height: 15px;
        }
        
    }
</style>